import { render, staticRenderFns } from "./InstallAppForm.vue?vue&type=template&id=c560cf36&scoped=true&"
import script from "./InstallAppForm.vue?vue&type=script&lang=js&"
export * from "./InstallAppForm.vue?vue&type=script&lang=js&"
import style0 from "./InstallAppForm.vue?vue&type=style&index=0&id=c560cf36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c560cf36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c560cf36')) {
      api.createRecord('c560cf36', component.options)
    } else {
      api.reload('c560cf36', component.options)
    }
    module.hot.accept("./InstallAppForm.vue?vue&type=template&id=c560cf36&scoped=true&", function () {
      api.rerender('c560cf36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Installer/InstallAppForm.vue"
export default component.exports